export var KeyHandlingMessage;
(function (KeyHandlingMessage) {
    KeyHandlingMessage["AddKeyEventListener"] = "ADD_KEY_EVENT_LISTENER";
    KeyHandlingMessage["RemoveKeyEventListener"] = "REMOVE_KEY_EVENT_LISTENER";
})(KeyHandlingMessage || (KeyHandlingMessage = {}));
//# sourceMappingURL=interface.js.map